import { useEffect, useState } from 'react';

/** The current time, refreshed every `everyMs`: live durations and "is it today" checks without impure renders. */
export function useNow(everyMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), everyMs);
    return () => window.clearInterval(id);
  }, [everyMs]);
  return now;
}
